import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";

function Food(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.473 0a1 1 0 011 1v7.626A3.307 3.307 0 017.17 11.93h-.433v10.955a1 1 0 11-2 0V11.93h-.433A3.308 3.308 0 011 8.626V1a1 1 0 012 0v7.626c0 .719.585 1.304 1.304 1.304h.433V1a1 1 0 012 0v8.93h.433c.72 0 1.303-.585 1.303-1.304V1a1 1 0 011-1zm11.242 2.076c.584.817 1.04 1.796 1.434 3.082.616 2.009.41 3.943-.568 5.304-.67.934-1.697 1.553-2.854 1.767v10.656a1 1 0 11-2 0l-.001-10.646a4.497 4.497 0 01-2.853-1.777c-.977-1.361-1.184-3.295-.568-5.304.393-1.286.85-2.265 1.434-3.082 1.8-2.514 4.177-2.514 5.976 0zm-2.988.105c-.396 0-.866.366-1.363 1.059-.454.635-.819 1.43-1.147 2.504-.205.666-.585 2.345.28 3.552.476.662 1.31 1.045 2.2 1.016.976.046 1.785-.354 2.26-1.016.866-1.207.485-2.886.28-3.552-.328-1.074-.693-1.87-1.148-2.504-.345-.484-.862-1.06-1.362-1.06z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

var MemoFood = React.memo(Food);
export default MemoFood;